export default __webpack_public_path__ + "assets/validCode.5ba84977.svg";